module.exports = __webpack_public_path__ + "static/media/appLogo.6101ddb1.svg";